import React from "react";
import PropTypes from "prop-types";
import GUID from "../helpers/uuidHelper";
import Checkbox from "@ingka/checkbox";
import Table, { TableBody, TableHeader } from "@ingka/table";
import Container from "../components/layout/Container";

const ArticlesDetailsView = ({ articleDetails, columnConfigurations, onSelectionChange }) => {
	const columns = Object.keys(columnConfigurations);
	return (
		<>
			<Container marginleft={"30px"} margintop={"10px"}>
				<h3>Article information</h3>
			</Container>
			<Container justifyContent={"flex-start"} marginleft={"80px"} marginright={"30px"} marginbottom={"30px"} maxwidth={"90%"}>
				<Table>
					<TableHeader sticky={false}>
						<tr>
							{columns.map(column => {
								const columnConfig = columnConfigurations[column];
								return <th key={GUID.Guid()}>{columnConfig.title}</th>;
							})}
						</tr>
					</TableHeader>

					{articleDetails.map(detail => {
						let articleDetail = { ...detail, salesPrice: detail.salesPrice === null || detail.salesPrice === undefined ? "" : detail.salesPrice.value };
						articleDetail = { ...articleDetail, totalPrice: articleDetail.salesPrice === null || articleDetail.salesPrice === "" ? "" : articleDetail.salesPrice * articleDetail.quantity };

						return (
							<TableBody key={GUID.Guid()}>
								<tr key={GUID.Guid()}>
									{columns.map(column => {
										const columnConfig = columnConfigurations[column];
										if (columnConfig.title === "") {
											return articleDetail.isSelected !== undefined ? (
												<td key={GUID.Guid()}>
													{<Checkbox id={articleDetail.rowId} checked={articleDetail.isSelected} onChange={e => onSelectionChange(e)} disabled={!articleDetail.isProcessible} />}
												</td>
											) : (
												<td key={GUID.Guid()}></td>
											);
										} else {
											return <td key={GUID.Guid()}>{articleDetail[column]}</td>;
										}
									})}
								</tr>
							</TableBody>
						);
					})}
				</Table>
			</Container>
		</>
	);
};

ArticlesDetailsView.propTypes = {
	articleDetails: PropTypes.array.isRequired,
	columnConfigurations: PropTypes.object.isRequired
};

export default ArticlesDetailsView;
